<template>
  <div
    class="automaticActivation"
  >
    <div
      class="btn"
    >
      <el-button
        size="small"
        type="primary"
        @click="handleBtn('note')"
      >
        接收短信设置
      </el-button>
      <el-button
        size="small"
        type="primary"
        @click="handleBtn('earlyWarning')"
      >
        激活预警
      </el-button>
    </div>
    <el-card>
      <el-form
        inline
        label-suffix="："
        size="small"
      >
        <el-form-item
          label="激活时间"
        >
          <el-date-picker
            v-model="searchForm.time"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @blur="dateBlur"
          />
        </el-form-item>
        <el-form-item
          label="激活状态"
        >
          <el-select
            v-model="searchForm.activateStatus"
            placeholder="请选择激活状态"
          >
            <el-option
              v-for="(item,index) in statusList"
              :key="index"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          label="设备SN号"
        >
          <el-input
            v-model="searchForm.deviceSn"
            maxlength="50"
            placeholder="请输入20位数字或字母"
          />
        </el-form-item>
        <el-form-item
          label="虚拟号"
        >
          <el-input
            v-model="searchForm.deviceVsn"
            maxlength="50"
            placeholder="请输入21位数字或字母"
          />
        </el-form-item>
        <el-form-item
          label="资源类型"
        >
          <el-select
            v-model="searchForm.resourceCode"
            placeholder="请选择资源类型"
          >
            <el-option
              label="全部"
              :value="''"
            />
            <el-option
              v-for="(item,index) in typeList"
              :key="index"
              :value="item.code"
              :label="item.name"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="handleBtn('search')"
          >
            查询
          </el-button>
          <el-button
            @click="handleBtn('reset')"
          >
            重置
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <div>
      <el-table
        :data="list"
      >
        <el-table-column
          width="65px"
          label="序号"
        >
          <template
            slot-scope="scope"
          >
            {{ ((page-1) * 10) +scope.$index+1 }}
          </template>
        </el-table-column>
        <el-table-column
          prop="deviceNo"
          label="设备SN号"
        />
        <el-table-column
          prop="accountId"
          label="虚拟号"
        />
        <el-table-column
          label="激活状态"
        >
          <template
            slot-scope="scope"
          >
            <span>
              {{ scope.row.statusName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="equityName"
          label="激活资源类型"
        />
        <el-table-column
          prop="openFailReason"
          label="激活失败原因"
        />
        <el-table-column
          prop="openDate"
          label="激活时间"
        />
        <el-table-column
          align="center"
          label="操作"
        >
          <template
            slot-scope="scope"
          >
            <el-button
              v-if="scope.row.openStatus!==1 && scope.row.openStatus!==2"
              type="text"
              size="mini"
              @click="handleBtn('activation',scope.row)"
            >
              激活
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :total="total"
        :page.sync="page"
        :limit.sync="limit"
        @handleSizeChange="getPageSize"
        @pagination="getPageSize"
      />
    </div>
    <el-dialog
      width="800px"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      title="激活预警"
      @close="dialogClose"
    >
      <el-table
        size="mini"
        :data="editForm.list"
      >
        <el-table-column
          align="center"
          label="序号"
          type="index"
          width="50"
        />
        <el-table-column
          align="center"
          prop="name"
          label="激活资源类型"
        />
        <el-table-column
          align="center"
          prop="deviceNo"
          label="SN号"
        />
        <el-table-column
          align="center"
          prop="openTime"
          label="激活时间"
        />
        <el-table-column
          align="center"
          prop="specUnit"
          label="有效时间（年）"
        >
          <template
            slot-scope="scope"
          >
            <span
              v-if="scope.row.code==='ZJY-MF'"
            >永久</span>
            <span
              v-else
            >{{ scope.row.specUnit }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="expiredTime"
          align="center"
          label="过期时间"
        >
          <template
            slot-scope="scope"
          >
            <span
              v-if="scope.row.code==='ZJY-MF'"
            >永久</span>
            <span
              v-else
            >{{ scope.row.expiredTime }}</span>
          </template>
        </el-table-column>
      </el-table>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          size="medium"
          @click="dialogVisible = false"
        >
          取消
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      v-if="messageDialogVisible"
      width="600px"
      :close-on-click-modal="false"
      :visible.sync="messageDialogVisible"
      title="接收短信设置"
      @close="messageDialogClose"
    >
      <el-form
        ref="editForm"
        :rules="rules"
        label-suffix="："
        size="small"
        label-width="150px"
        :model="editForm"
      >
        <el-form-item
          prop="phone"
          label="接收短信号码"
        >
          <el-input
            v-model="editForm.phone"
            type="textarea"
            placeholder="请输入手机号码,并且逗号隔开"
          />
          <span
            style="color:#909399;font-size:12px;"
          >可输入1-10个手机号码，多条手机号码以(英文)逗号区分</span>
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          size="medium"
          @click="messageDialogVisible = false"
        >
          取消
        </el-button>
        <el-button
          type="primary"
          size="medium"
          @click="handleImport"
        >
          确定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getResourceActivationAutoList,
  getResourceActivationPhones,
  updateResourceActivationPhone,
  getResourceActivationWarning,
  activation
} from '@/api/productOperation/financialCenter/resourceActivation.js';
import Pagination from '@/components/Pagination'; // Secondary package based on el-pagination
export default {
  components: {
    Pagination
  },
  props: {
    typeList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    const validatePhone = (rule, value, callback) => {
      const pattern = new RegExp(/^1\d{10}$/);
      if (value === '') {
        callback(new Error('请输入手机号'));
      } else {
        const str = value.split(',');
        if (str.some((item) => item.length !== 11 && item.length !== 0 && !pattern.test(item))) {
          callback(new Error('请输入正确的手机号'));
        }
        if (str.length > 10) {
          callback(new Error('最多只能10个手机号'));
        }
        callback();
      }
    };
    return {
      pickerMinDate: '', // 选中的第一个时间
      minDate: 90, // 时间范围
      pickerOptions: {
        onPick: (obj) => {
          this.pickerMinDate = new Date(obj.minDate).getTime();
        },
        disabledDate: (time) => {
          if (this.pickerMinDate) {
            const day1 = this.minDate * 24 * 3600 * 1000;
            const maxTime = this.pickerMinDate + day1;
            const minTime = this.pickerMinDate - day1;
            return time.getTime() > maxTime || time.getTime() < minTime;
          }
        }
      },
      dialogVisible: false,
      messageDialogVisible: false,
      editForm: {},
      list: [],
      searchForm: {
        time: [],
        activateStatus: '',
        deviceSn: '',
        deviceVsn: '',
        resourceCode: '',
        startDate: '',
        endDate: ''
      },
      total: 0,
      page: 1,
      limit: 10,
      statusList: [
        { label: '全部', value: '' },
        { label: '激活中', value: 1 },
        { label: '激活成功', value: 2 },
        { label: '激活失败', value: 3 }
      ], // 激活状态
      rules: {
        phone: [{ validator: validatePhone, trigger: 'change', type: 'number' }]
      }
    };
  },
  mounted() {
    this.page = 1;
    // this.messageDialogVisible = true;
    this.getData();
  },
  methods: {
    handleStatus(val) {
      if (!val) return;
      // eslint-disable-next-line eqeqeq
      return this.statusList.find((item) => item.value === Number(val)).label;
    },
    handleImport() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          const str = this.editForm.phone.split(',');
          var r = str.filter((item) => {
            return item.length > 0;
          });
          const phone = [...new Set(r)];
          const phones = phone.join(',');
          if (r.length !== phone.length) {
            this.$message.warning('已去除重复的手机号');
          }
          updateResourceActivationPhone({
            phones
          }).then((res) => {
            if (res.code === '0') {
              this.messageDialogVisible = false;
              this.$message.success('操作成功');
            }
          });
        }
      });
    },
    getAlertSettings() {
      getResourceActivationWarning().then((res) => {
        if (res.code === '0') {
          this.editForm.list = res.data;
          this.$forceUpdate();
        }
      });
    },
    dialogClose() {
      this.dialogVisible = false;
    },
    messageDialogClose() {
      this.messageDialogVisible = false;
    },
    handleBtn(e, data) {
      if (e === 'activation') {
        this.$confirm('是否继续激活', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            activation(data.srcId).then((res) => {
              if (res.code === '0') {
                this.getData();
                this.$message({
                  type: 'success',
                  message: res.message || '激活成功'
                });
              }
            });
          })
          .catch((err) => {
            console.log(err);
          });
        // 激活
      } else if (e === 'earlyWarning') {
        // 预警设置
        this.getAlertSettings();
        this.dialogVisible = true;
      } else if (e === 'note') {
        // 短信
        this.messageDialogVisible = true;
        getResourceActivationPhones().then((res) => {
          if (res.code === '0' && res.data) {
            this.editForm = { phone: res.data };
          } else {
            this.editForm = { phone: '' };
          }
        });
      } else if (e === 'search') {
        if (this.searchForm.time !== null) {
          this.searchForm.startDate = this.searchForm.time[0] || '';
          this.searchForm.endDate = this.searchForm.time[1] || '';
        } else {
          this.searchForm.startDate = null;
          this.searchForm.endDate = null;
        }
        this.page = 1;
        this.getData();
      } else if (e === 'reset') {
        this.searchForm = {
          time: [],
          activateStatus: '',
          deviceSn: '',
          deviceVsn: '',
          resourceCode: '',
          startDate: '',
          endDate: ''
        };
        this.page = 1;
        this.getData();
        this.dateBlur();
      }
    },
    dateBlur() {
      this.pickerMinDate = '';
    },
    getPageSize({ page, limit }) {
      this.page = page;
      this.limit = limit;
      this.getData();
    },
    getData() {
      getResourceActivationAutoList({
        pageSize: this.limit,
        pageNum: this.page,
        ...this.searchForm
      }).then((res) => {
        this.list = res.data.list.map((item) => {
          return {
            ...item,
            statusName:
              // eslint-disable-next-line eqeqeq
              item.openStatus == 1
                ? '激活中'
                : item.openStatus === 2 // eslint-disable-next-line eqeqeq
                  ? '激活成功'
                  : '激活失败'
          };
        });
        this.total = res.data.total;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.automaticActivation {
  .btn {
    margin: 0 10px 10px;;
    display: flex;
    justify-content: flex-end;
    margin-right: 10px;
  }
}
</style>
